export default {

  "meta-title": "TARISLAND",
  "meta-description": "Tarisland es un MMORPG en PC y móviles, con incursiones, diversas clases juego cruzado, y un vasto mundo por explorar. Embárquense juntos en su aventura épica.",
  "meta-keywords": "tarisland,taris,comme wow,mmo,mmorpg,multiplateforme,mmomobile,mmoPC",
  "meta-name": "Sitio web oficial de Tarisland",
  "meta-image": "${HOST_NAME}/assets/images/share.jpg",
  "meta-og-site_name": "Sitio web oficial de Tarisland",
  "meta-og-title": "Sitio web oficial de Tarisland",
  "meta-og-description": "Experimentarás un MMORPG multi-plataforma clásico, y disfrutarás de la diversión de las incursiones intensas con compañeros de equipo confiables.",
  "meta-og-url": "${HOST_NAME}/${LANG}/home.html",
  "meta-og-url2": "${HOST_NAME}/${LANG}/index.html",
  "meta-og-image": "${HOST_NAME}/assets/images/share.jpg",
  "meta-twitter-site": "${HOST_NAME}",
  "meta-twitter-title": "Sitio web oficial de Tarisland",
  "meta-twitter-description": "Experimentarás un MMORPG multi-plataforma clásico, y disfrutarás de la diversión de las incursiones intensas con compañeros de equipo confiables.",
  "meta-twitter-url": "${HOST_NAME}/${LANG}/home.html",
  "meta-twitter-url2": "${HOST_NAME}/${LANG}/index.html",
  "meta-twitter-image": "${HOST_NAME}/assets/images/share.jpg",


  "email_illegal": "Dirección de correo electrónico incorrecta. Por favor, verifica y vuelve a enviar.",
  "horizon_tip": "Para una mejor experiencia, por favor gire su dispositivo.",

  'downloadPc': "Please download on PC",

  "area": "Área",
  "select-area": "Seleccione el área",
  "server": "Servidor",
  "select-server": "Seleccione el servidor",
  "character-name": "Nombredel Personaje",
  "select-character": "Seleccione el personaje",
  "please-select": "Seleccione",
  "not-found-role": "Información del personaje no encontrada",
  'loading': '加載中....',
  'pls_input_info': '請輸入您的登錄信息。',
  'FlowHasNotBegin': 'The event has not started yet',
  'FlowHasEnd': 'The event has ended',

  // 复制到剪贴板内容 需要拼接
  "copy_clipboard-text1": "¡Conviértete en mi compañero en Tarisland!\nHaz clic/toque en: ",
  "copy_clipboard-text2": "(enlace exclusivo)\nSi el enlace no funciona, utiliza el siguiente código de invitación:",
  "friends-completed": "amigos completaron",
  "no-friends-completed": "0 amigos completaron",
  "pop_invitedlist_s": "COMPLET.",
  "pop_invitedlist_f": "INCOMP.",
  "gift3": "Paquete de Crecimiento de la T1",
  "gift5": "Espíritu del Lobo de Hielo (Permanente)",
  "gift6": "Espíritu del Lobo de Hielo (1 Día)",
  "gift1": "Tarjeta de regalo de $100",
  "gift2": "Tarjeta de regalo de $50",
  "gift4": "Espíritu del Tigre de Fuego (Permanente)",


  "invite_link_upper_limit": "El enlace o código de invitación ha alcanzado el número máximo de usos.",
  "invite_link_disabled": "Enlace de invitación no válido o código expirado. Confírmalo con lo invitador.",
  "enter_your_invitation_code": "Ingresa tu código de invitación",
  "act_not_start": "El evento no ha comenzado.",
  "act_finished": "El evento ha terminado.",
  "download_pc": "Descargar en PC",
  "email_error": "Correo electrónico no válido. Confírmalo.",
  "loadding": "Cargando...",
  "check_my_raffle_history": "Ver historial de sorteos",
  "no_raffle_history": "Sin historial de sorteos",
  "system-error": "Error del sistema",
  "cant-invite-self": "No puedes invitarte a ti mismo",

}